module.exports = __webpack_public_path__ + "img/alelo.36a47bb3.svg";